import { SET_FASTEN_CONNECTIONS, SET_FASTEN_LOADING } from '../constants';

interface FastenState {
  connections: Record<string, any[]>;
  loading: boolean;
}

const initialState: FastenState = {
  connections: {},
  loading: false,
};

export default function fastenReducer(state = initialState, action: any): FastenState {
  switch (action.type) {
    case SET_FASTEN_CONNECTIONS:
      return {
        ...state,
        connections: { ...state.connections, [action.payload.projectId]: action.payload.connections },
      };
    case SET_FASTEN_LOADING:
      return { ...state, loading: action.payload };
    default:
      return state;
  }
}
